import { FirestoreDataConverter } from "firebase/firestore";
import { Recipe } from "lib-shared-code";
import { PartialConverter } from "../types";
import { genericConverter } from "./generic-converter";

export const recipeConverter: FirestoreDataConverter<Recipe> &
  PartialConverter<Recipe> = genericConverter<Recipe>();
